import { Form } from '@medely/ui-kit';
import React, { useEffect } from 'react';
import { w2InterestSchema } from './w2InterestSchema';
import { W2InterestDialogContainerProps } from './interface';
import { useW2Interest } from '@mp/hooks/useW2Interest';
import { W2InterestDialog } from './W2InterestDialog';
import { useW2interestEvent } from '@mp/hooks';

export const W2InterestDialogContainer = ({ open, onClose }: W2InterestDialogContainerProps) => {
  const { setW2Interest, isLoading } = useW2Interest();
  const { trackW2InterestDialogView } = useW2interestEvent();

  useEffect(() => {
    if (open) {
      trackW2InterestDialogView();
    }
  }, [open, trackW2InterestDialogView]);

  const handleSubmit = (values: { w2_interest: number }) => {
    setW2Interest(values.w2_interest === 1 ? true : false);
    onClose();
  };

  return (
    <Form handleSubmit={handleSubmit} schema={w2InterestSchema} defaultValues={{ w2_interest: 1 }}>
      <W2InterestDialog open={open} onClose={onClose} isLoading={isLoading} />
    </Form>
  );
};
